export const borderWidth = {
  none: 0,
  xsmall: 1,
  small: 2,
  medium: 4,
  large: 8
} as const;

export type BorderWidth = keyof typeof borderWidth;
